import EA from '../helpers/init';
import Api from '../helpers/axios';

const setError = (wrapEl, msgEl, msg) => {
    if (wrapEl) wrapEl.classList.toggle('has-error', !!msg);

    if (msgEl) {
        msgEl.textContent = msg || '';
        msgEl.classList.toggle('show', !!msg);
    }
};

export default EA.Methods.newsletterForm = ($this) => {
    const form = $this.querySelector('.newsletter-form');
    form.setAttribute('novalidate', '');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const email = $this.querySelector('input[name="email"]').value;
        const emailEl = $this.querySelector('input[name="email"]');
        const privacy = $this.querySelector('input[name="privacy_policy"]').checked;
        const privacyEl = $this.querySelector('input[name="privacy_policy"]');
        const thankYouWrapper = $this.querySelector('.thank-you-wrapper');

        const inputWrap = form.querySelector('.input-wrap');
        const checkboxWrap = form.querySelector('.checkbox-wrap');

        const emailErrEl = inputWrap?.querySelector('.error-message');
        const privacyErrEl = checkboxWrap?.querySelector('.error-message');
        const formErrEl = form.querySelector(':scope > .error-message');

        // Clear previous errors
        setError(inputWrap, emailErrEl, '');
        setError(checkboxWrap, privacyErrEl, '');
        setError(null, formErrEl, '');

        let valid = true;

        // EMAIL VALIDATION START
        let emailMsg = '';
        if(emailEl.validity.valueMissing) {
            emailMsg = 'Upišite e-mail adresu.';
        } else if(emailEl.validity.typeMismatch) {
            emailMsg = 'Upišite ispravnu e-mail adresu.';
        }

        if(emailMsg) {
            valid = false;
            setError(inputWrap, emailErrEl, emailMsg);
        }
        // EMAIL VALIDATION END

        // PRIVACY CHECKBOX VALIDATION START
        let privacyMsg = '';
        if(!privacyEl.checked) {
            privacyMsg = 'Morate prihvatiti Politiku privatnosti.';
        }

        if(privacyMsg) {
            valid = false;
            setError(checkboxWrap, privacyErrEl, privacyMsg);
        }
        // PRIVACY CHECKBOX VALIDATION END
        if(!valid) return;

        try {
            const response = await Api.post('newsletter/subscribe', {
                email,
                privacy_policy: privacy
            });
            
            form.reset();
            form.classList.add('hide');
            thankYouWrapper.classList.add('show');

            console.log(response);
        } catch (error) {
            const errParams = error.response.data.data.params;
            const [field, message] = Object.entries(errParams)[0] || [];

            if(message) {
                setError(null, formErrEl, message);
                console.error('Newsletter error:', error);
            }
        }
    });
};